<template>
  <div class="toggle-more-section">
    <div ref="toggleMoreSectionContainer">
      <div
        ref="toggleMoreSectionText"
        :class="!showSection && 'toggle-more-section--minimised-display'"
      >
        <slot></slot>
      </div>
    </div>

    <button
      v-if="showToggleButton"
      :class="buttonClasses"
      :aria-expanded="`${showSection}`"
      @click="toggleSection"
    >
      <div
        v-if="!hasCustomText"
        class="toggle-more-section__button primary--text"
      >
        <span class="toggle-more-section__action-text">
          {{ showSection ? `Show less` : `Show more` }}
          <span class="d-sr-only">{{ sectionName }}</span>
        </span>
        <v-icon small color="primary">{{
          showSection ? mdiChevronUp : mdiChevronDown
        }}</v-icon>
      </div>
      <slot name="toggleButtonText" />
    </button>
  </div>
</template>

<script>
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";

export default {
  name: "ToggleMoreSection",
  props: {
    sectionName: { type: String, default: "" },
    buttonClasses: { type: String, default: "" },
  },
  data() {
    return {
      showSection: false,
      showToggleButton: false,
      // Icons
      mdiChevronDown,
      mdiChevronUp,
    };
  },
  computed: {
    hasCustomText() {
      return !!this.$slots.toggleButtonText;
    },
  },
  mounted() {
    const { toggleMoreSectionText, toggleMoreSectionContainer } = this.$refs;
    this.showToggleButton =
      toggleMoreSectionText?.scrollHeight >
      toggleMoreSectionContainer?.clientHeight;
  },
  methods: {
    toggleSection() {
      this.showSection = !this.showSection;
      this.$emit("toggle", this.showSection);
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-more-section {
  &__button {
    font-size: 14px;
  }
  &__action-text {
    vertical-align: top;
  }
  &--minimised-display {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
